// redux/slices/applyNowSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { postRequest } from '../apis/ApiInstence';

export const submitApplication = createAsyncThunk(
  'applyNow/submitApplication',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await postRequest('applynow', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const applyNowSlice = createSlice({
  name: 'applyNow',
  initialState: {
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitApplication.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(submitApplication.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(submitApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearState } = applyNowSlice.actions;
export default applyNowSlice.reducer;
